import { io, type Socket } from 'socket.io-client';

const URL = (import.meta.env.VITE_CHAT_WS_URL as string | undefined) ?? 'ws://localhost:4103/chat';

let singleton: Socket | null = null;

export function getChatSocket(token: string | null): Socket {
  if (singleton && singleton.auth && (singleton.auth as { token?: string }).token === token) {
    return singleton;
  }
  if (singleton) {
    singleton.disconnect();
    singleton = null;
  }
  singleton = io(URL, {
    auth: { token },
    autoConnect: false,
    transports: ['websocket'],
    reconnection: true,
  });
  return singleton;
}

export interface ChatAck<T = unknown> {
  ok: boolean;
  data?: T;
  error?: { code: string; message: string };
}

export function emitWithAck<T>(
  socket: Socket,
  event: string,
  payload: unknown,
  timeoutMs = 10_000,
): Promise<ChatAck<T>> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`${event} timeout`)), timeoutMs);
    socket.emit(event, payload, (ack: ChatAck<T>) => {
      clearTimeout(timer);
      resolve(ack);
    });
  });
}
